import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { DashboardSelectorEl } from 'common/widgets/dashboard-selector';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
export function template() {
  return jsx("div", null, jsx(ButtonEl, {
    attrs: {
      icon: this.state.isLoading ? "spinner" : "",
      theme: this.attr("theme"),
      pressed: this.state.isOpen,
      disabled: this.attr("disabled")
    },
    on: {
      click: this.helpers.handleSaveButtonClicked
    }
  }, this.attr("label")), this.attr("tooltip") && jsx(TooltipEl, {
    attrs: {
      placement: Placement.Top,
      'body-level': true,
      text: this.attr("tooltip")
    }
  }), jsx(DashboardSelectorEl, {
    attrs: {
      open: this.state.isOpen,
      'user-id': this.attr("user-id"),
      'disable-create-dashboard': true,
      'search-placeholder': this.attr("search-placeholder")
    },
    class: {
      'align-right': this.attr("align-right")
    },
    on: {
      select: this.helpers.handleDashboardSelected,
      menuchange: this.helpers.handleMenuChanged
    },
    props: {
      controller: this.dashboardController
    }
  }));
}